import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { Section } from '@/features/app-shell/section'

export const Route = createFileRoute('/_dashboard/activity/')({
	beforeLoad: () => {
		throw redirect({ to: '/activity/actions' })
	},
	component: RouteComponent,

	head: () => ({
		meta: [
			{
				title: 'Activity | BitLyft AIR®',
			},
		],
	}),
})

function RouteComponent() {
	return (
		<Section>
			<Outlet />
		</Section>
	)
}
